/* eslint-disable class-methods-use-this */
/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Product Mapping Service
 * This service is used to get product mapping data
 * @file ProductMappingService.js
 * @author Mohamed yasar arabath M
 */

import Framework, { BaseService } from '@greenville/framework';
import {
  PRODUCT_MAPPING_REQUESTED,
  PRODUCT_MAPPING_FETCHED,
  PRODUCT_MAPPING_FAILED
} from '../../../common/constants';


export default class ProductMappingService extends BaseService {
  constructor() {
    super(PRODUCT_MAPPING_REQUESTED, 'productMappingStatus');
  }

  fetch(productId) {
    return this.getClient('marin').post('/product-mappings/resolve', { productId });
  }

  handleEvent(eventName, { ppid }) {
    const client = this.getClient('marin');

    return client.post('/product-mappings/resolve', { ppid });
  }

  handleResponse({ data }) {
    Framework.getEventManager().publish(PRODUCT_MAPPING_FETCHED, data);
  }

  handleError(error) {
    Framework.getEventManager().publish(PRODUCT_MAPPING_FAILED, error);
  }
}
